import { Box, Text } from "@chakra-ui/react";
import { LRPrivText } from "@verivest/logrocket/src";
import { VeriHeading } from "@verivest/shared-components";
import { InvestmentModel } from "@verivest/shared-components/src/api/models";
import React from "react";
import { formatToMoney, getProperty } from "../../../../utils/utils";
import { FundingInstructionsLink } from "./funding-instructions/FundingInstructionsModal";

const ValueBox = ({
  title,
  value,
}: {
  title?: string;
  value?: React.ReactNode;
}) => {
  return (
    <Box
      borderTopColor="border.input"
      borderTopWidth="1px"
      width="100%"
      mt="24px"
      pt="24px"
    >
      <VeriHeading textStyle={"labelSmall"}>{title}</VeriHeading>
      <Text mt="8px">{value}</Text>
    </Box>
  );
};
const RightPanelInvestment = ({
  investment = {},
  opportunityName,
  opportunityImage,
  offeringType,
  investingAs,
  investmentAmount,
  fundingMethod,
  distributionPreference,
}: {
  investment: InvestmentModel;
  opportunityName?: string;
  opportunityImage?: string;
  offeringType?: string;
  investingAs?: string;
  investmentAmount?: number;
  fundingMethod?: string;
  distributionPreference?: string;
}) => {
  const parsedOpportunityImage =
    opportunityImage || getProperty(investment, "offering.opportunity.imgUrl");
  const parsedOpportunityName =
    opportunityName || getProperty(investment, "offering.opportunity.name");
  const parsedOfferingType =
    offeringType || getProperty(investment, "offering.offeringType");
  const parsedInvestmentAmount =
    investmentAmount || getProperty(investment, "amount");
  const parsedInvestingAs =
    investingAs ||
    (getProperty(investment, "account.nameOfRecord") &&
      getProperty(investment, "account.nameOfRecord") +
        ` (${getProperty(investment, "account.accountType")})`);
  const parsedFundingMethod =
    fundingMethod || getProperty(investment, "paymentMethod");
  const parsedDistributionPreference =
    distributionPreference ||
    getProperty(investment, "distributionPreference.distributionMethod");
  return (
    <Box>
      <VeriHeading textStyle="labelSmall">Selected Investment</VeriHeading>
      {parsedOpportunityImage && (
        <Box
          my="16px"
          width="100%"
          paddingTop="min(308px, 100%)"
          backgroundSize="contain"
          backgroundRepeat="no-repeat"
          backgroundPosition="left"
          backgroundColor="bg.grey"
          borderRadius={4}
          style={{ backgroundImage: `url('${parsedOpportunityImage}')` }}
        />
      )}
      <Box>
        <Text>
          {parsedOpportunityName}
          {parsedOfferingType && ` (${parsedOfferingType})`}
        </Text>
      </Box>
      {parsedInvestmentAmount && (
        <ValueBox
          title="Investment amount"
          value={formatToMoney(parsedInvestmentAmount, true)}
        />
      )}
      {parsedInvestingAs && (
        <ValueBox
          title="Investing as"
          value={<LRPrivText>{parsedInvestingAs}</LRPrivText>}
        />
      )}
      {parsedFundingMethod && (
        <ValueBox
          title="Funding method"
          value={
            <>
              {parsedFundingMethod}
              <FundingInstructionsLink
                linkContent={
                  <>
                    {" "}
                    <span>&#8226;</span> View instructions
                  </>
                }
                investment={investment}
                paymentMethod={parsedFundingMethod}
              />
            </>
          }
        />
      )}
      {parsedDistributionPreference && (
        <ValueBox title="Distributions" value={parsedDistributionPreference} />
      )}
    </Box>
  );
};

export default RightPanelInvestment;
